/**
 * Statistics API service
 * Handles campaign analytics and performance metrics
 */

import api from './api';
import type { CampaignStatistics, StatisticsParams } from '../types/statistics';

export const statisticsService = {
  /**
   * Get statistics for a specific campaign
   * @param campaignId Campaign ID
   * @param params Optional date range parameters
   */
  async getCampaignStatistics(
    campaignId: number,
    params?: StatisticsParams
  ): Promise<CampaignStatistics> {
    const response = await api.get<CampaignStatistics>(
      `/api/campaigns/${campaignId}/statistics`,
      { params }
    );
    return response.data;
  },

  /**
   * Get aggregated statistics across all campaigns
   * @param params Optional date range parameters
   */
  async getAllCampaignsStatistics(
    params?: StatisticsParams
  ): Promise<CampaignStatistics> {
    const response = await api.get<CampaignStatistics>(
      '/api/statistics',
      { params }
    );
    return response.data;
  },
};

export default statisticsService;
